import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";

const HelmetWrapper = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
}) => {
  return (
    <Helmet>
      {/* Page Title */}
      <title>{title}</title>

      {/* Meta Description */}
      {description && (
        <meta name="description" content={description} />
      )}

      {/* Keywords */}
      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      {/* Open Graph */}
      {ogTitle && (
        <meta property="og:title" content={ogTitle} />
      )}

      {ogDescription && (
        <meta property="og:description" content={ogDescription} />
      )}
    </Helmet>
  );
};

HelmetWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  keywords: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
};

export default HelmetWrapper;
